/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
export type IShipmentIssueDetailsFragment = { __typename?: 'ShipmentIssue' } & Pick<
  Types.IShipmentIssue,
  'id' | 'createdAt' | 'updatedAt' | 'dueAt' | 'priority' | 'state' | 'summary'
> & {
    createdBy: { __typename?: 'User' } & Pick<
      Types.IUser,
      'id' | 'parentUserId' | 'firstName' | 'lastName'
    >
    fault?: Types.Maybe<
      { __typename?: 'ShipmentIssueFault' } & Pick<Types.IShipmentIssueFault, 'id' | 'fault'>
    >
    notes: Array<{ __typename?: 'Note' } & Pick<Types.INote, 'id' | 'body'>>
    owner: { __typename?: 'ShipmentIssueFollower' } & Pick<
      Types.IShipmentIssueFollower,
      'followerType' | 'followerId' | 'firstName' | 'lastName' | 'nickname'
    >
    reason?: Types.Maybe<
      { __typename?: 'ShipmentIssueReason' } & Pick<Types.IShipmentIssueReason, 'id' | 'reason'>
    >
    subscribers: Array<
      { __typename?: 'ShipmentIssueFollower' } & Pick<
        Types.IShipmentIssueFollower,
        'followerId' | 'followerType' | 'firstName' | 'lastName' | 'nickname'
      >
    >
    suggestedOwners: Array<
      { __typename?: 'ShipmentIssueSuggestedOwner' } & Pick<
        Types.IShipmentIssueSuggestedOwner,
        'role'
      > & {
          owner?: Types.Maybe<
            { __typename?: 'ShipmentIssueFollower' } & Pick<
              Types.IShipmentIssueFollower,
              'followerId' | 'followerType' | 'firstName' | 'lastName'
            >
          >
        }
    >
    issueResolutionSteps?: Types.Maybe<
      Array<
        { __typename?: 'IssueResolutionStep' } & Pick<
          Types.IIssueResolutionStep,
          | 'id'
          | 'issueResolutionStepId'
          | 'description'
          | 'stepSequence'
          | 'completed'
          | 'completedAt'
          | 'completedById'
        >
      >
    >
    type: { __typename?: 'ShipmentIssueType' } & Pick<
      Types.IShipmentIssueType,
      'id' | 'categoryId' | 'name' | 'description' | 'stepsToResolve' | 'canManuallyResolve'
    > & {
        category?: Types.Maybe<
          { __typename?: 'ShipmentIssueCategory' } & Pick<
            Types.IShipmentIssueCategory,
            'id' | 'name'
          >
        >
      }
    updater: { __typename?: 'User' } & Pick<
      Types.IUser,
      'id' | 'parentUserId' | 'firstName' | 'lastName'
    >
    issueStateTransitions: Array<
      { __typename?: 'ShipmentIssueStateTransition' } & Pick<
        Types.IShipmentIssueStateTransition,
        'id' | 'state' | 'createdAt'
      > & { createdBy: { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'> }
    >
  }

export const ShipmentIssueDetailsFragmentDoc = gql`
  fragment ShipmentIssueDetails on ShipmentIssue {
    id
    createdAt
    updatedAt
    createdBy {
      id
      parentUserId
      firstName
      lastName
    }
    dueAt
    fault {
      id
      fault
    }
    notes {
      id
      body
    }
    owner {
      followerType
      followerId
      firstName
      lastName
      nickname
    }
    priority
    reason {
      id
      reason
    }
    state
    subscribers {
      followerId
      followerType
      firstName
      lastName
      nickname
    }
    suggestedOwners {
      owner {
        followerId
        followerType
        firstName
        lastName
      }
      role
    }
    summary
    issueResolutionSteps {
      id
      issueResolutionStepId
      description
      stepSequence
      completed
      completedAt
      completedById
    }
    type {
      id
      categoryId
      name
      description
      stepsToResolve
      category {
        id
        name
      }
      canManuallyResolve
    }
    updater {
      id
      parentUserId
      firstName
      lastName
    }
    issueStateTransitions {
      id
      state
      createdAt
      createdBy {
        id
        fullName
      }
    }
  }
`
